import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import MoneyGiftForm from '../components/MoneyGiftForm';
import { FaEdit, FaTrash } from 'react-icons/fa';
import translations from '../../../translations';

const MoneyGiftPage = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [editing, setEditing] = useState(false);
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'en');
  const t = translations[language];

  const fetchBankInfo = () => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/moneygifts/${id}`)
      .then(res => setData(res.data))
      .catch(() => setData(null));
  };

  const handleDelete = async () => {
    if (!window.confirm(t.deleteInfoConfirmation)) return;

    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/moneygifts/${id}`);
      setData(null);
      setEditing(true);
    } catch (err) {
      console.error('Failed to delete:', err);
    }
  };

  const handleSuccess = () => {
    setEditing(false);
    fetchBankInfo();
  };

  useEffect(() => {
    fetchBankInfo();
  }, [id]);

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white rounded shadow">
      <h2 className="text-2xl font-bold mb-6">{t.manageMoneyGift}</h2>

      {!editing && data ? (
        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <span className="font-medium text-gray-700">{t.bankName}</span>
            <span className="font-semibold">{data.bank_name}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="font-medium text-gray-700">{t.accountNumber}</span>
            <span className="font-semibold">{data.account_number}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="font-medium text-gray-700">{t.receiverName}</span>
            <span className="font-semibold">{data.receiver_name}</span>
          </div>

          <div className="mt-6 flex space-x-4">
            <button
              onClick={() => setEditing(true)}
              className="bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded flex items-center"
            >
              <FaEdit className="mr-2" /> {t.edit}
            </button>
            <button
              onClick={handleDelete}
              className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded flex items-center"
            >
              <FaTrash className="mr-2" /> {t.delete}
            </button>
          </div>
        </div>
      ) : (
        <MoneyGiftForm id={id} onSaved={handleSuccess} />
      )}
    </div>
  );
};

export default MoneyGiftPage;
